var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 265 265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill: #000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.27,69.08c-1.75,.64-3.46,1.36-5.14,2.14L76.74,12.27c3.31-1.54,6.71-2.95,10.17-4.22l22.36,61.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.21,71.65c-1.68,.81-3.33,1.7-4.93,2.64L65.23,18.32c3.15-1.86,6.39-3.6,9.7-5.19l28.28,58.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.41,74.82c-1.6,.97-3.16,2.02-4.67,3.12L54.37,25.47c2.96-2.16,6.01-4.21,9.15-6.12l33.89,55.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.92,78.55c-1.5,1.13-2.95,2.33-4.36,3.58L44.26,33.65c2.74-2.44,5.58-4.77,8.51-6.98l39.15,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.81,82.82c-1.39,1.27-2.72,2.6-3.99,3.99L35,42.78c2.48-2.7,5.08-5.3,7.78-7.78l44.03,47.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.13,87.56c-1.25,1.41-2.45,2.86-3.58,4.36L26.67,52.77c2.21-2.93,4.54-5.77,6.98-8.51l48.48,43.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.94,92.74c-1.1,1.51-2.15,3.07-3.12,4.67L19.35,63.52c1.91-3.14,3.96-6.19,6.12-9.15l52.47,38.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.29,98.28c-.94,1.6-1.83,3.25-2.64,4.93L13.13,74.93c1.59-3.31,3.33-6.55,5.19-9.7l55.97,33.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.22,104.13c-.78,1.68-1.5,3.39-2.14,5.14L8.05,86.91c1.27-3.46,2.68-6.86,4.22-10.17l58.95,27.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.74,110.22c-.61,1.75-1.15,3.53-1.61,5.33L4.19,99.33c.92-3.58,1.99-7.09,3.19-10.54l61.36,21.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.88,116.53c-.43,1.8-.79,3.62-1.08,5.48L1.57,112.06c.56-3.65,1.28-7.26,2.13-10.8l63.18,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.65,123.01c-.25,1.84-.44,3.71-.54,5.61L.21,124.99c.21-3.69,.56-7.35,1.07-10.95l64.37,8.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65,132.5c0,.96,.02,1.91,.06,2.85L.12,138.01c-.08-1.83-.12-3.66-.12-5.51s.04-3.68,.12-5.51l64.94,2.66c-.04,.94-.06,1.89-.06,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.65,141.99L1.28,150.96c-.51-3.61-.87-7.26-1.07-10.96l64.9-3.62c.1,1.9,.29,3.77,.54,5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.88,148.47L3.7,163.74c-.85-3.54-1.57-7.15-2.13-10.8l64.23-9.95c.29,1.86,.65,3.68,1.08,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.74,154.77L7.38,176.21c-1.2-3.45-2.27-6.96-3.19-10.54l62.94-16.22c.46,1.8,1,3.58,1.61,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.22,160.87l-58.95,27.39c-1.54-3.31-2.95-6.71-4.22-10.17l61.03-22.36c.64,1.74,1.36,3.46,2.14,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.29,166.72l-55.97,33.05c-1.86-3.15-3.6-6.39-5.19-9.7l58.52-28.28c.81,1.68,1.7,3.33,2.64,4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.94,172.26l-52.47,38.37c-2.16-2.96-4.21-6.01-6.12-9.15l55.47-33.89c.97,1.6,2.02,3.16,3.12,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.13,177.43l-48.48,43.31c-2.44-2.74-4.77-5.58-6.98-8.51l51.88-39.15c1.13,1.5,2.33,2.95,3.58,4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.81,182.18l-44.03,47.82c-2.7-2.48-5.3-5.08-7.78-7.78l47.82-44.03c1.27,1.39,2.6,2.72,3.99,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.92,186.45l-39.15,51.88c-2.93-2.21-5.77-4.54-8.51-6.98l43.3-48.48c1.41,1.25,2.86,2.45,4.36,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.41,190.18l-33.89,55.47c-3.14-1.91-6.19-3.96-9.15-6.12l38.37-52.47c1.51,1.1,3.07,2.15,4.67,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.21,193.35l-28.28,58.52c-3.31-1.59-6.55-3.33-9.7-5.19l33.05-55.97c1.6,.94,3.25,1.83,4.93,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.27,195.92l-22.36,61.03c-3.46-1.27-6.86-2.68-10.17-4.22l27.39-58.95c1.68,.78,3.39,1.5,5.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.55,197.87l-16.22,62.94c-3.58-.92-7.09-1.99-10.54-3.19l21.43-61.36c1.75,.61,3.53,1.14,5.33,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.01,199.2l-9.95,64.23c-3.65-.56-7.26-1.28-10.8-2.13l15.27-63.18c1.8,.43,3.62,.79,5.48,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.62,199.89l-3.63,64.9c-3.69-.21-7.35-.56-10.95-1.07l8.97-64.37c1.84,.25,3.71,.44,5.61,.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.01,264.88c-1.83,.08-3.66,.12-5.51,.12s-3.68-.04-5.51-.12l2.66-64.94c.94,.04,1.89,.06,2.85,.06s1.91-.02,2.85-.06l2.66,64.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.96,263.72c-3.61,.51-7.26,.87-10.96,1.07l-3.62-64.9c1.9-.1,3.77-.29,5.61-.54l8.97,64.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.74,261.3c-3.54,.85-7.15,1.57-10.8,2.13l-9.95-64.23c1.86-.29,3.68-.65,5.48-1.08l15.27,63.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.21,257.62c-3.45,1.2-6.96,2.27-10.54,3.19l-16.22-62.94c1.8-.47,3.58-1,5.32-1.61l21.44,61.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.26,252.73c-3.31,1.54-6.71,2.95-10.17,4.22l-22.36-61.03c1.74-.64,3.46-1.36,5.14-2.14l27.39,58.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.77,246.68c-3.15,1.86-6.39,3.6-9.7,5.19l-28.28-58.52c1.68-.81,3.33-1.7,4.93-2.64l33.05,55.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.63,239.53c-2.96,2.16-6.01,4.21-9.15,6.12l-33.89-55.47c1.6-.97,3.16-2.02,4.67-3.12l38.37,52.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.74,231.35c-2.74,2.44-5.58,4.77-8.51,6.98l-39.15-51.88c1.5-1.13,2.95-2.33,4.35-3.58l43.31,48.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230,222.22c-2.48,2.7-5.08,5.3-7.78,7.78l-44.03-47.82c1.39-1.27,2.72-2.6,3.99-3.99l47.82,44.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.33,212.23c-2.21,2.93-4.54,5.77-6.98,8.51l-48.48-43.31c1.25-1.4,2.45-2.85,3.58-4.35l51.88,39.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.65,201.48c-1.91,3.14-3.96,6.19-6.12,9.15l-52.47-38.37c1.1-1.51,2.15-3.07,3.12-4.67l55.47,33.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.87,190.07c-1.59,3.31-3.33,6.55-5.19,9.7l-55.97-33.05c.94-1.6,1.83-3.25,2.64-4.93l58.52,28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.95,178.09c-1.27,3.46-2.68,6.86-4.22,10.17l-58.95-27.39c.78-1.68,1.5-3.4,2.14-5.14l61.03,22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.81,165.67c-.92,3.58-1.99,7.09-3.19,10.54l-61.36-21.44c.61-1.74,1.14-3.52,1.61-5.32l62.94,16.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.43,152.94c-.56,3.65-1.28,7.26-2.13,10.8l-63.18-15.27c.43-1.8,.79-3.62,1.08-5.48l64.23,9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.79,140c-.2,3.7-.56,7.35-1.07,10.96l-64.37-8.97c.25-1.84,.44-3.71,.54-5.61l64.9,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265,132.5c0,1.85-.04,3.68-.12,5.51l-64.94-2.66c.04-.94,.06-1.89,.06-2.85s-.02-1.91-.06-2.85l64.94-2.66c.08,1.83,.12,3.66,.12,5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.79,124.99l-64.9,3.63c-.1-1.9-.29-3.77-.54-5.61l64.37-8.97c.51,3.6,.86,7.26,1.07,10.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.43,112.06l-64.23,9.95c-.29-1.86-.65-3.68-1.08-5.48l63.18-15.27c.85,3.54,1.57,7.15,2.13,10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.81,99.33l-62.94,16.22c-.47-1.8-1-3.58-1.61-5.33l61.36-21.43c1.2,3.45,2.27,6.96,3.19,10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.95,86.91l-61.03,22.36c-.64-1.75-1.36-3.46-2.14-5.14l58.95-27.39c1.54,3.31,2.95,6.71,4.22,10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.87,74.93l-58.52,28.28c-.81-1.68-1.7-3.33-2.64-4.93l55.97-33.05c1.86,3.15,3.6,6.39,5.19,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.65,63.52l-55.47,33.89c-.97-1.6-2.02-3.16-3.12-4.67l52.47-38.37c2.16,2.96,4.21,6.01,6.12,9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.33,52.77l-51.88,39.15c-1.13-1.5-2.33-2.95-3.58-4.36l48.48-43.3c2.44,2.74,4.77,5.58,6.98,8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230,42.78l-47.82,44.03c-1.27-1.39-2.6-2.72-3.99-3.99l44.03-47.82c2.7,2.48,5.3,5.08,7.78,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.74,33.65l-43.31,48.48c-1.4-1.25-2.85-2.45-4.35-3.58l39.15-51.88c2.93,2.21,5.77,4.54,8.51,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.63,25.47l-38.37,52.47c-1.51-1.1-3.07-2.15-4.67-3.12l33.89-55.47c3.14,1.91,6.19,3.96,9.15,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.77,18.32l-33.05,55.97c-1.6-.94-3.25-1.83-4.93-2.64l28.28-58.52c3.31,1.59,6.55,3.33,9.7,5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.26,12.27l-27.39,58.95c-1.68-.78-3.4-1.5-5.14-2.14l22.36-61.03c3.46,1.27,6.86,2.68,10.17,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.21,7.38l-21.44,61.36c-1.74-.61-3.52-1.15-5.32-1.61L165.67,4.19c3.58,.92,7.09,1.99,10.54,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.74,3.7l-15.27,63.18c-1.8-.43-3.62-.79-5.48-1.08L152.94,1.57c3.65,.56,7.26,1.28,10.8,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.96,1.28l-8.97,64.37c-1.84-.25-3.71-.44-5.61-.54L140,.21c3.7,.2,7.35,.56,10.96,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.01,.12l-2.66,64.94c-.94-.04-1.89-.06-2.85-.06s-1.91,.02-2.85,.06L126.99,.12c1.83-.08,3.66-.12,5.51-.12s3.68,.04,5.51,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.62,65.11c-1.9,.1-3.77,.29-5.61,.54L114.04,1.28c3.6-.51,7.26-.86,10.95-1.07l3.63,64.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.01,65.8c-1.86,.29-3.68,.65-5.48,1.08L101.26,3.7c3.54-.85,7.15-1.57,10.8-2.13l9.95,64.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.55,67.13c-1.8,.46-3.58,1-5.33,1.61L88.79,7.38c3.45-1.2,6.96-2.27,10.54-3.19l16.22,62.94Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRays);
export default __webpack_public_path__ + "static/media/rays.58d0af61ccd85d05322395d6919aa202.svg";
export { ForwardRef as ReactComponent };